<template>
  <div >
    <el-drawer @reload="$reloadHandle" title="审核" size="40%" :before-close="handleClose" :visible.sync="drawer"
               direction="rtl" append-to-body  custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">



        <template>
          <div>
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class=""  style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                    单据号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">
                       {{ formData.billNo }}
                    </span>
                  </div>
                </div>


             <div class="headline">请填写对单据的处理结果:</div>
                  <vxe-table :stripe="true"
                  :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                  :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                  show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                  :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                  :data="formData.workLines"  >
                  <vxe-column type="checkbox" width="60"></vxe-column>
                  <vxe-column field="businessBillNo" title="单据号" width="180" >
                    <template #default="{row}">
                      <vxe-input v-model="row.businessBillNo" placeholder="请输入" disabled>
                      </vxe-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="businessResult" title="结果" width="250">
                    <template #default="{row}">
                      <vxe-input v-model="row.businessResult" placeholder="请输入">
                      </vxe-input>
                    </template>
                  </vxe-column>
                </vxe-table>
              </el-form>
            </div>
          </div>
        </template>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="orderFollowUp">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 关闭弹窗 -->

  </div>
</template>
<script>
import request from "@/router/axios";
import api from "@/api/projectApi";
export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi','dataId','wf'],
  components: {

  },
  created(){
    console.log("wf--------------",this.wf)
    this.formData.id = this.dataId
    if (this.wf) {
      this.formData.processId = this.wf.processId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
    }

  },
  data() {
    return {
      show3: false,
      showInRemark:"",
      form2: {
        desc: '',
        name: "",
      },
      showOrderPop: false,
      drawer: true,
      formData: {
        processId: null,
        id: null,
        messageContent: "",
      },
      dispatchStats: [
        {id:1,label:'通过'},{id:2,label:'不通过'}],
      orderRemarkData:{
        dispatchStat:1

      }
    }
  },
  mounted() {
    this.getData();
    // this.getDispatch();
  },
  methods: {
    getData() {
      //获取对应的工单信息
      request({
        url: api.workBill.getDataUrl,
        method: 'post',
        data: {
          id: this.formData.id
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.formData = response.data.data;
      })
    },

    orderFollowUp() {
      this.$mask.open()
      if (this.wf) {
        this.formData.messageContent = this.wf.messageContent
      }
      console.log("审核内容提交:",this.formData);
      this.formData.stat = 5;
      request({
        url: api.workBill.doOperateUrl,
        method: 'post',
        data:this.formData,
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if(response.data.type == "success"){
          this.$message({ message:response.data.content,type: 'success'});  
            this.$emit('closeD', false)
          this.drawer = false;
          clearTimeout(this.timer);
          console.log('同一 成功');
      
        }else{
          this.$message({ message:response.data.content,type: 'warning'});
        }
      })
      this.$mask.close()

    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('followUpOrderRemark2', 0)
    },
    handleClose() {
      this.drawer = false;
      this.$emit('followUpOrderRemark2', 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }
    .table-detail tr {
      margin-bottom: 10px;
      display: block;
      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }
      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0,);
      }
    }}

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
  ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
  }
}
.headline{
  font-size: 14px;
    font-weight: 400;
    color: #262626;
    padding: 10px 0;
}
</style>
